var _a;
import { makeFormContext } from './Form';
var email = {
    props: { id: 'email', name: 'email', autoCorrect: 'off', spellCheck: false },
    required: true,
    blurError: function (value) {
        if (value && !value.match(emailRegex)) {
            return 'Your email is incomplete.';
        }
        return '';
    },
    changeError: function () { return ''; },
    fieldNames: ['email'],
};
export var emailValues = {
    email: email,
};
export var EmailContext = (_a = makeFormContext({
    name: 'Email',
    formValues: emailValues,
}), _a.Context), EmailProvider = _a.Provider, useEmail = _a.useForm;
var emailRegex = /^([a-zA-Z0-9_.\-+])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
//# sourceMappingURL=Email.js.map